import React, {useEffect, useState} from 'react';
import { Modal } from 'react-bootstrap';
import Descriptor from '../Reusables/Descriptor';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import { trim } from '../Reusables/Function';
import '../../scss/popups/add_notes.scss';

import closeIcon from '../../images/popups/upload/closeicon.png';

function AddNotes(props) {
    const {page, entityId, showNotes, setShowNotes, isNoteAdded, 
        setNodeAdded, notes, setNotes, setDefaultNotes, defaultNotes, notesId} = props;
    const navigate = useNavigate();
    const [enable, setEnable] = useState(false);

    const handleNotes = () => {
        var data = null;
        var endpoint = "";

        if(defaultNotes == "") {
            endpoint = "/api/entity/notes/add";
            data = {
                EntityId: entityId,
                Details: notes
            }
        } else {
            endpoint = "/api/entity/notes/update";
            data = {
                IdEntityNotesRelation: notesId,
                Details: notes
            }
        }        

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.PostDetails(endpoint, accesstoken, data, (data) => {
                    if(data.status == 200) {
                        setNotes("");
                        setNodeAdded(!isNoteAdded)
                        setShowNotes(false);
                        setDefaultNotes("");
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleCancelNote = () => {
        setShowNotes(false);
        setDefaultNotes("");
    }

    useEffect(() => {
        if(showNotes && trim(notes) != null && trim(notes) != "") {
            setEnable(true)
        } else {
            setEnable(false)
        }
    }, [notes])

    return (
        <>
            <Modal
                show={showNotes}
                onHide={handleCancelNote} className='add-notes-popup'
                centered>
                <Modal.Body className='add-notes-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleCancelNote}/>
                    </div>
                    <div className='add-notes-content'>
                        <div className='add-note-popup-header'>{`${defaultNotes == "" ? "Add Note" : "Edit Note"}`}</div>
                        <div className='entity-notes-container'>
                            {(showNotes) && 
                            <div className='add-note-container'>
                                <Descriptor defaultdescription={defaultNotes} setDescription={setNotes}/>
                                <div className='buttons-container'>
                                    <div className='add-button'>
                                        <button disabled={!enable} className={enable ? 'button-enable' : 'button-disable'} onClick={handleNotes}>Save</button>
                                    </div>
                                    <div className='cancel-button'>
                                        <button className='button-enable' onClick={handleCancelNote}>Cancel</button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddNotes;